export default "__VITE_ASSET__Cb30NuyH__"